<template>
  <NuxtLayout
    name="top"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main">
        <AreaTopMap
          v-if="areaId"
          :now="now"
          :area-id="areaId"
          :page-title="title"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <AreaCountryCityTable
          :area-id="areaId"
        />

        <div class="ranking">
          <RankingPoint
            target-display-type="area"
            :target-id="`/${areaId}/`"
            target-point-type="city"
            :now="now"
          />
          <div
            v-if="!isWebViewFlag"
            id="ads-btf5-pc"
            class="ads-btf5-pc"
          />
          <div
            id="ads-btf1-sp-small-height"
            class="ads-btf1-sp"
          />
          <RankingPoint
            target-display-type="area"
            :target-id="`/${areaId}/`"
            target-point-type="landmark"
            :now="now"
          />
        </div>

        <RadarLinkCard
          :link="`/onebox/tenki/world/radar/${areaId}/`"
          :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/thumb/area_${areaId}/prec.webp`"
          :target-area="areaLabelMap[areaId]"
        />

        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <CommonCountryList />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

const route = useRoute()
const areaId = route.params.area
if (!areaLabelMap[areaId]) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}

const breadcrumb = [
  {
    text: '世界天気',
    link: `${runtimeConfig.public.hostDomain}/onebox/tenki/world/`
  },
  {
    text: `${areaLabelMap[areaId]}`
  }
]
const title = `${areaLabelMap[areaId]}の天気 - ウェザーニュース`
useCommonHead({
  title: title,
  description: `【${areaLabelMap[areaId]}各地の2週間先までの天気予報】${areaDescriptionCountries[areaId]}など旅行や出張先の天気も簡単検索！各地の雨雲レーダーは48時間先まで確認できます。天気に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。`,
  keywords: `${areaLabelMap[areaId]},2週間,当たる`,
  appTitle: areaLabelMap[areaId],
  appCountKey: route.path.toLowerCase(),
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_color@2x.png`
})
useCommonJsonld({
  breadcrumb: breadcrumb
})

const now = dayjs().unix()
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}
.main:has(.worldWeather) {
    gap: 10px;
}
.worldMap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ranking {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ads-btf5-pc {
  min-height: 50px;
  margin: 0px auto;
}
.ads-btf1-sp {
  min-height: 50px;
  margin: 0px auto;
}
</style>
